/*=========================================================================================
  File Name: module-mws-state.js
  Description: MWS Module State — token cache cho kết nối MISA WebSocket Service
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export const defaultMwsState = {
	//Token MWS cache ở FE: { ExpiredDate: number(epoch ms, trừ 15% biên), Token: object MWSTokenResponse }
	//Module này KHÔNG persist (reducer vuex-persistance loại trừ) — token chỉ ở memory, tránh XSS đọc localStorage
	MWSToken: null
};

export default {
	...defaultMwsState
};
